/** @format */

import React from "react"
import { Container } from "./NetworkSelection.styled"
import Dropdown from "@ui-library/core/Dropdown"
import { DroplistItemType, DroplistType } from "@ui-library/core/"
import {
	Network,
	NetworkSelectionProps,
	Networks,
} from "./NetworkSelection.types"

const NetworkSelection = ({
	onSelect,
	networks,
	selectedNetworkId,
}: NetworkSelectionProps) => {
	const innerOnSelect = (data: Network) => {
		onSelect(data)
	}

	const mapNetwork = (n: Network): DroplistItemType<Network> => ({
		icon: null,
		label: n.name,
		key: n.id,
		value: n,
	})
	const generateList = (networks: Networks): DroplistType<Network> => {
		let list: DroplistType<Network> = []

		const networksNoEmpty = networks ?? []
		const independantContrats = networksNoEmpty?.filter(n => n.id === null)
		const networksSelection = networksNoEmpty?.filter(n => n.id !== null)

		if (independantContrats.length > 0) {
			list = [...independantContrats.map(mapNetwork)]
		}
		if (networksSelection.length > 0) {
			list = [
				...list,
				{
					key: "network",
					title: "Réseau",
					list: networksSelection.map(mapNetwork),
				},
			]
		}
		return list
	}
	const netWorkList = generateList(networks)

	return (
		networks &&
		networks.length > 1 && (
			<Container>
				<Dropdown
					defaultLabel="Réseau"
					list={netWorkList}
					onSelect={innerOnSelect}
					value={networks?.find(n => (n.id ?? "") === (selectedNetworkId ?? ""))}
					testID="network-selection-dropdown"
					key="network-selection-dropdown"
				/>
			</Container>
		)
	)
}

export default NetworkSelection
